import { createFileRoute } from '@tanstack/react-router'

import { TopicSection } from '@/topic/components/TopicSection/TopicSection'

export const Route = createFileRoute(
  '/_learning/_my-learning/user/progress/view/$topic',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()

  return <TopicSection topicSlug={params.topic} returnUrl="/user/progress" />
}
